module.exports = __webpack_public_path__ + "static/media/18b-02_movil.93ae6eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18b/18b-02_movil.jpg
// module id = 227
// module chunks = 0